import { request } from "../api/client";
import { getAccessToken } from "./auth-session";

const authHeaders = () => ({
  Authorization: `Bearer ${getAccessToken()}`,
});

export const fetchMyProfile = async () => {
  return request("/auth/google/me", { headers: authHeaders() });
};

export const updateMyProfile = async (payload) => {
  return request("/auth/profile", {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
};

export const removeMyAccount = async () => {
  return request("/auth/account", {
    method: "DELETE",
    headers: authHeaders(),
  });
};

export const getCalendarToken = async () => {
  return request("/auth/calendar-token", { headers: authHeaders() });
};

export const regenerateCalendarToken = async () => {
  return request("/auth/calendar-token/regenerate", {
    method: "POST",
    headers: authHeaders(),
  });
};
